import type { FC } from 'react';

import LoginForm from '@/features/auth/components/LoginForm';
import { useLoginPage } from '@/features/auth/hooks/useLoginPage.hook';

const LoginPage: FC = () => {
  const {
    email,
    password,
    errors,
    submitError,
    isSubmitting,
    onChangeEmail,
    onChangePassword,
    onSubmit,
  } = useLoginPage();

  return (
    <div className="flex flex-col gap-6">
      <header className="flex flex-col items-center gap-2 text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-500 text-2xl font-extrabold text-white shadow-lg">
          S
        </div>
        <h1 className="text-2xl font-extrabold text-[var(--color-ink)]">Shoutt Admin</h1>
        <p className="text-sm text-[var(--color-ink-muted)]">Secure administrator access</p>
      </header>
      <LoginForm
        email={email}
        password={password}
        errors={errors}
        submitError={submitError}
        isSubmitting={isSubmitting}
        onChangeEmail={onChangeEmail}
        onChangePassword={onChangePassword}
        onSubmit={onSubmit}
      />
    </div>
  );
};

export default LoginPage;
